import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { ICustomerSensitivityScore } from '../interfaces/customer-sensitivity-score';

@Injectable({
  providedIn: 'root',
})
export class CustomerSensitivityScoresService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  entityTitle: string = 'Reason';

  getAllCustomerScores(): Promise<ICustomerSensitivityScore[]> {
    const url = '/api/DeployPriority/CustomerSensitivityScores';

    return this.handleRequest<any[]>(
      this.http.get<ICustomerSensitivityScore[]>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  updateCustomerScores(dto: ICustomerSensitivityScore): Promise<void> {
    const url = '/api/DeployPriority/CustomerSensitivityScores';

    return this.handleRequest<void>(
      this.http.post<void>(url, dto),
      this.handlersFactory.getForReadAll(),
    );
  }
}
